import React from 'react';
import { Star, ShieldCheck, Users, MapPin, ArrowRight, Quote } from 'lucide-react';
const GOOGLE_PROFILE_URL = 'https://maps.app.goo.gl/RHx11FTgfNUyLUbi9';
const trustSignals = [{
  icon: ShieldCheck,
  title: 'Fully Insured',
  description: 'Licensed and insured for your complete peace of mind.'
}, {
  icon: Users,
  title: 'Family Owned',
  description: 'A family-run business that treats your property like our own.'
}, {
  icon: MapPin,
  title: 'Locally Owned',
  description: 'Proudly based in and serving the Lancaster, NY community.'
}];
const reviews = [{
  name: 'Adam King',
  service: 'Lawn Leveling, Grading & Sod Installation',
  text: 'Bryan and James did an amazing job turning my un-level and uneven yard, that was full of weeds, into a green lush lawn. Bryan was amazing to work with from start to finish — very knowledgeable in his line of work. We went with Kentucky bluegrass sod and I couldn\u2019t have made a better choice. If you\u2019re looking for any lawn work or a new lawn, these guys are hands down the go-to guys!'
}, {
  name: 'Frank Martin',
  service: 'Lawn Rolling, Care & Maintenance',
  text: 'I called for an estimate for topsoil for my right of way. Once they looked at the area, they recommended I call the town because the town should provide the topsoil. I had no idea. The honesty of the company causes me to put Hauser\u2019s at the top of the list the next time I need work done. Thank you!'
}, {
  name: 'Megan McCormack',
  service: 'Mowing',
  text: 'Very impressed with this company. They removed a substantial amount of overgrowth and vegetation from my backyard in a short amount of time. Their work ethic and professionalism was exceptional and, best of all, the price was reasonable. I will definitely consider this company first for any future projects!'
}];
export function Reviews() {
  return <section id="reviews" className="py-16 md:py-24" data-id="element-146">
      <div className="container max-w-screen-2xl" data-id="element-147">
        <div className="text-center max-w-[800px] mx-auto mb-14" data-id="element-148">
          <p className="text-sm font-semibold uppercase tracking-widest text-primary mb-3" data-id="element-149">
            Why Choose Us
          </p>
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4" data-id="element-150">
            Trusted Across Western New York
          </h2>
          <p className="text-lg text-muted-foreground" data-id="element-151">
            Homeowners, property managers, and businesses count on Hauser's
            Complete Care for dependable, professional service in every season.
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 mb-16" data-id="element-152">
          {trustSignals.map((item, index) => <div key={index} className="flex flex-col items-center text-center rounded-2xl bg-background p-8 shadow-sm border border-border/50" data-id="element-153">
              <div className="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary" data-id="element-154">
                <item.icon className="h-7 w-7" data-id="element-155" />
              </div>
              <h3 className="text-lg font-bold mb-1" data-id="element-156">{item.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed" data-id="element-157">
                {item.description}
              </p>
            </div>)}
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-158">
          {reviews.map((review, index) => <div key={index} className="flex flex-col bg-background rounded-2xl p-8 shadow-sm border border-border/50 relative" data-id="element-159">
              <Quote className="absolute top-8 right-8 h-8 w-8 text-primary/10" aria-hidden="true" data-id="element-160" />
              <div className="flex text-yellow-400 mb-5" aria-hidden="true" data-id="element-161">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-current" data-id="element-162" />)}
              </div>
              <p className="text-foreground mb-6 relative z-10 flex-1 text-sm leading-relaxed" data-id="element-163">
                "{review.text}"
              </p>
              <div className="border-t border-border/50 pt-4" data-id="element-164">
                <p className="font-bold" data-id="element-165">{review.name}</p>
                <p className="text-sm text-muted-foreground" data-id="element-166">
                  {review.service}
                </p>
              </div>
            </div>)}
        </div>

        <div className="rounded-2xl bg-primary/5 border border-primary/20 p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left" data-id="element-167">
          <div className="flex flex-col md:flex-row items-center gap-5" data-id="element-168">
            <div className="flex flex-col items-center md:items-start" data-id="element-169">
              <div className="flex text-yellow-400 mb-1" aria-hidden="true" data-id="element-170">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-6 w-6 fill-current" data-id="element-171" />)}
              </div>
              <span className="text-sm text-muted-foreground" data-id="element-172">
                Rated by our customers on Google
              </span>
            </div>
            <div className="max-w-md" data-id="element-173">
              <h3 className="text-xl font-bold mb-1" data-id="element-174">
                See what more of our neighbors are saying
              </h3>
              <p className="text-muted-foreground text-sm" data-id="element-175">
                Read all our verified reviews and leave one of your own on our
                Google Business profile.
              </p>
            </div>
          </div>
          <a href={GOOGLE_PROFILE_URL} target="_blank" rel="noopener noreferrer" className="inline-flex h-12 shrink-0 items-center justify-center rounded-md bg-primary px-8 text-base font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90" data-id="element-176">
            Read More on Google
            <ArrowRight className="ml-2 h-4 w-4" data-id="element-177" />
          </a>
        </div>
      </div>
    </section>;
}